console.log("init Proteus Activations -- 0.13");

// treatments logic

  // window.sessionStorage.removeItem("KIZ-Holiday-Gift-Cards");
